import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { getPageDataPath } from '../shared';
import { asyncComponents } from '../async-components';
import { onClientEntry, onInitialClientRender } from '../../../../browser-api';

// All three promises are required for the app to work, so we use Promise.all
const results = await Promise.all([
  fetch(
    `/${getPageDataPath(window.location.pathname.replace('/index.html', ''))}`
  ).then(data => data.json()),
  asyncComponents[window.componentChunkName](),
  onClientEntry
]);

const pageData = results[0];
const pageComponent = results[1];
const pageElement = React.createElement(pageComponent.default, {
  pageContext: pageData.result.pageContext
});

const container = document.getElementById('___app');
const containerInnerHtml = container.innerHTML;
try {
  hydrateRoot(container, pageElement);
} catch (error) {
  // Keep already rendered HTML if hydration fails.
  container.innerHTML = containerInnerHtml;
  // oxlint-disable-next-line no-console
  console.error(error);
}

onInitialClientRender();
